import { Module } from 'vuex';

/**
 *
 * @type {Module<ShippingObject>}
 */
const shipping = {
    namespaced: true,
    state: {
        address_line_1: '' ,
        address_line_2: '',
        city: '',
        company: '',
        country: '',
        email: '',
        first_name: '',
        last_name: '',
        package_code: '',
        service_code: '',
        shipping_email: '',
        shipping_method_preview: '',
        state: '',
        zip_code: '',
        price_total: '',
    },
    mutations: {
        setAddressLine1: (s, value) => s.address_line_1 = value,
        setAddressLine2: (s, value) => s.address_line_2 = value,
        setCity: (s, value) => s.city = value,
        setCompany: (s, value) => s.company = value,
        setCountry: (s, value) => s.country = value,
        setEmail: (s, value) => s.email = value,
        setFirstName: (s, value) => s.first_name = value,
        setLastName: (s, value) => s.last_name = value,
        setPackageCode: (s, value) => s.package_code = value,
        setServiceCode: (s, value) => s.service_code = value,
        setShippingEmail: (s, value) => s.shipping_email = value,
        setShippingMethodPreview: (s, value) => s.shipping_method_preview = value,
        setState: (s, value) => s.state = value,
        setZipCode: (s, value) => s.zip_code = value,
        setPriceTotal: (s, value) => s.price_total = value,
    },
};

export default shipping;
